<template>
  <CrudList
      title="Reporte de Ayuda"
      storeName="Spot_helps"
      labelAddNew="Agregar"
      sortable
      canSearch
      :canShow="true"
      :canEdit="false"
      label-show="Ver"
      :canExport="true"
      next-link="/admin/help_options"
      :breadcrumbs="[
        {
          text: 'Información y soporte',
          disabled: false,
          href: '/admin/spot_helps'
        },
        {
          text: 'Reporte de ayuda',
          disabled: false,
          href: '#'
        }
      ]"
  >
    <!-- Columna combinada -->
    <template v-slot:picture="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-list-item-avatar v-if="item.picture" class="banner">
            <img :src="item.picture" alt="" />
          </v-list-item-avatar>
        </v-col>
      </v-row>
    </template>
    <template v-slot:user_info="{ item }">
      <div class="table-cell-fixed">
        <div class="d-flex align-center" style="gap: 12px;">
          <div>
            <div><b>Email:</b> {{ item.user_id?.email || "-" }}</div>
            <div><b>Teléfono:</b> {{ item.user_id?.phone_number || "-" }}</div>
            <div><b>Fecha:</b> {{ formatDate(item.created_at) }}</div>
            <div>
              <b>Spot:</b>
              {{ item.spot_id?.address || "" }}
              <br />
              {{ item.spot_id?.alias_id ? `( ${item.spot_id.alias_id} )` : "" }}
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- Spot -->
    <template v-slot:spot_id="{ item }">
      <div class="table-cell-fixed">
        <div>
          {{ item.spot_id?.address || "" }}<br />
          {{ item.spot_id?.alias_id ? `( ${item.spot_id.alias_id} )` : "" }}
        </div>
      </div>
    </template>

    <!-- Opción de ayuda -->
    <template v-slot:help_option_id="{ item }">
      <div class="table-cell-fixed">
        {{ item.help_option_id?.title || "" }}
      </div>
    </template>

    <!-- Comentario -->
    <template v-slot:comment="{ item }">
      <div class="table-cell-fixed">
        <v-container
            id="scroll-target"
            style="max-height: 100%; max-width: 600px;"
            class="overflow-y-auto"
        >
          <v-row v-scroll:#scroll-target="onScroll">
            <p>{{ item.comment }}</p>
          </v-row>
        </v-container>
      </div>
    </template>
  </CrudList>
</template>
<style>
.table-cell-fixed {
  min-height: 200px;
  max-height: 200px;
  display: flex;
  align-items: center;
  overflow-y: auto; /* opcional */
}
.banner{
  width: 80px !important;
  height: auto !important;
  border-radius: 0 !important;
}
</style>

<script>
import CrudList from "@/components/Crud/CrudList";
import CrudFormMixin from "@/mixins/crud_form";
export default {
  mixins: [CrudFormMixin],
  components: { CrudList },
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
  },
};
</script>
